import React from "react";

export const PayrollIcon: React.FC<{ height?: number; width?: number }> = ({
  height,
  width,
}) => {
  return (
    <svg
      width={width ? `${width}px` : "15px"}
      height={height ? `${height}px` : "15px"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4C13.3137 4 16 6.68629 16 10ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10.6562 6H7.5V14H9.19141V11.4062H10.6133C11.2279 11.4062 11.7513 11.293 12.1836 11.0664C12.6185 10.8398 12.9505 10.5234 13.1797 10.1172C13.4089 9.71094 13.5234 9.24219 13.5234 8.71094C13.5234 8.17969 13.4102 7.71094 13.1836 7.30469C12.9596 6.89583 12.6341 6.57682 12.207 6.34766C11.7799 6.11589 11.263 6 10.6562 6ZM9.19141 10.0508H10.3398C10.6654 10.0508 10.9336 9.99479 11.1445 9.88281C11.3581 9.76823 11.5169 9.61068 11.6211 9.41016C11.7279 9.20703 11.7812 8.97396 11.7812 8.71094C11.7812 8.44531 11.7279 8.21354 11.6211 8.01562C11.5169 7.8151 11.3581 7.66016 11.1445 7.55078C10.931 7.4388 10.6602 7.38281 10.332 7.38281H9.19141V10.0508Z"
        fill="#989DA2"
      />
    </svg>
  );
};
